function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as encode from './encode';
export var line = {
  vgMark: 'line',
  encodeEntry: function encodeEntry(model) {
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, encode.baseEncodeEntry(model, {
      align: 'ignore',
      baseline: 'ignore',
      color: 'include',
      size: 'ignore',
      orient: 'ignore',
      theta: 'ignore'
    })), encode.pointPosition('x', model, {
      defaultPos: 'mid'
    })), encode.pointPosition('y', model, {
      defaultPos: 'mid'
    })), encode.nonPosition('size', model, {
      vgChannel: 'strokeWidth' // VL's line size is strokeWidth

    })), encode.defined(model));
  }
};
export var trail = {
  vgMark: 'trail',
  encodeEntry: function encodeEntry(model) {
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, encode.baseEncodeEntry(model, {
      align: 'ignore',
      baseline: 'ignore',
      color: 'include',
      size: 'include',
      orient: 'ignore',
      theta: 'ignore'
    })), encode.pointPosition('x', model, {
      defaultPos: 'mid'
    })), encode.pointPosition('y', model, {
      defaultPos: 'mid'
    })), encode.nonPosition('size', model)), encode.defined(model));
  }
};